'use client';

import React from 'react';
import clsx from 'clsx';
import type { AuthenticationIntroProps } from './AuthenticationIntro.types';
import { FeedbackMessageBanner } from '../FeedbackMessageBanner/FeedbackMessageBanner';

export const AuthenticationIntro: React.FC<AuthenticationIntroProps> = ({ title, subtitle, banner, className, children }) => {
  return (
    <div className={clsx('grid gap-12 p-tb-1-5 w-full', className)}>
      <h1 className="regular text-center primary-text-color-main-activeSelected">{title}</h1>

      {subtitle ? <h2 className="text-center primary-text-color-submain-normal">{subtitle}</h2> : null}

      {banner ? (
        <FeedbackMessageBanner
          message={banner.message}
          variant={banner.variant}
          className={banner.className}
          reserveEmptyPlaceholder={banner.reserveEmptyPlaceholder}
        />
      ) : null}

      {children ? <div className="grid form-min-height w-full">{children}</div> : null}
    </div>
  );
};
